<template>
  <v-container fill-height>
    <v-row>
      <v-col md="8" offset-md="2">
        <v-form ref="form" v-model="valid">
          <v-card>

            <v-toolbar dark color="indigo">
              <v-toolbar-title>Добавить новую запись</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-icon>mdi-plus-circle-outline</v-icon>
            </v-toolbar>
          
            <v-card-text>

              <v-select v-model="room"
                        :items="rooms" 
                        item-text="text"
                        item-value="value"
                        label="Комната" 
                        prepend-icon="mdi-home"
                        :rules="[v => !!v || 'обязательное поле']">
              </v-select>

              <v-file-input v-model="image" 
                            label="Изображение" 
                            accept="image/*" 
                            :rules="[v => !!v || 'обязательное поле']">
              </v-file-input>

              <v-row class="d-flex flex-row justify-space-around mb-10 mt-20">
                <v-date-picker v-model="date" locale="ru" :first-day-of-week="1" prepend-icon="mdi-calendar"></v-date-picker>
                <v-time-picker v-model="time" format="24hr" prepend-icon="mdi-clock" min="09:00" max="18:00"></v-time-picker>
              </v-row>
              
              <v-row>
                <v-col>
                  <v-text-field
                    placeholder="Продолжительность:" 
                    prepend-icon="mdi-timer-sand"
                    disabled
                    type="text">
                  </v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="duration_hour"
                    label="Часы"
                    type="number"
                    :rules="[v => !!v || 'обязательное поле']">
                  </v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="duration_min"
                    label="Минуты"
                    type="number"
                    :rules="[v => !!v || 'обязательное поле']">
                  </v-text-field>
                </v-col>
              </v-row>

              <v-textarea v-model="description" 
                          label="Дополнительная информация" 
                          type="text" 
                          prepend-icon="mdi-information-outline">
              </v-textarea>

            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="success" :disabled="!valid" @click="onCreateMeetup">Создать запись</v-btn>
            </v-card-actions>

          </v-card>
        </v-form>

        <v-overlay :value="loadingStatus">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-snackbar v-model="snackbar">
          Новая запись добавлена!
        </v-snackbar>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  
  export default {
    data: () => ({
      room: '',
      image: null,
      date: new Date().toISOString().substr(0, 10),
      time: '09:00',
      duration: '',
      description: '',
      rooms: [
        { text: 'Первая комната', value: 'room1' },
        { text: 'Вторая комната', value: 'room2' },
        { text: 'Третья комната (большая)', value: 'room3' }
      ],
      duration_hour: '',
      duration_min: '',
      valid: true,
      snackbar: false,
      snackbarStatus: false
    }),
    methods: {
      onCreateMeetup(){
        const newMeetup = {
            room: this.room,
            image: this.image,
            timestamp: Date.parse(this.date + ' ' + this.time),
            duration: this.duration_hour * 60 + +this.duration_min,
            description: this.description
        };
        this.$store.dispatch('createMeetup', newMeetup);
        this.$refs.form.reset();
        //this.$router.push('/meetups')
        this.snackbarStatus = true;
      }
    },
    computed: {
      loadingStatus(){
        return this.$store.state.loading;
      }
    },
    watch: {
      loadingStatus: function(){
        if(!this.loadingStatus && this.snackbarStatus){
          this.snackbar = true
        }
      }
    }
  }

</script>

<style scoped>

</style>
